<div
  class="attachment_wrapper"
  [class.read_only]="readOnly"
  [hidden]="attachments.length === 0"
  title="{{ 'commons:attachment.display' | translate }}"
>
  <button
    class="attachment_icon"
    [class.open]="visibleAttachment"
    (click)="toggleAttachmentDisplay()"
    [attr.aria-expanded]="visibleAttachment"
  >
    <span class="nodisplay">{{ 'commons:attachment.display' | translate }}</span>
    <span class="attachment_counter" [attr.aria-hidden]="true">{{ attachments.length }}</span>
    <span class="attachment_inner" [attr.aria-hidden]="true"></span>
  </button>
  <div class="attachment_popup" [hidden]="readOnly || !visibleAttachment" (mouseleave)="hideAttachment()">
    <ul>
      <li *ngFor="let elem of attachments">
        <a *ngIf="canDownloadAttachment(elem)" [title]="formatSize(elem)" [href]="elem.source" class="message flex-row" [download]>
          {{ formatSize(elem) }}
        </a>
        <div *ngIf="!canDownloadAttachment(elem)" class="link flex-row">{{ formatSize(elem) }}</div>
        <button
          *ngIf="canRemoveLink"
          class="removeLink"
          role="button"
          (click)="removeLink(elem)"
          title="{{ 'commons:attachment.removeLink' | translate }}"
        >
          <span class="nodisplay">{{ 'commons:attachment.removeLink' | translate }}</span>
        </button>
      </li>
    </ul>
  </div>
</div>
